import { Card, Space } from "antd";
import React, { useState } from "react";
import CommonCalendar from "../../LeavesComponents/calender";

const ShiftSchedule = () => {
    const events = [
        { date: "2024-11-04", type: "A", content: "A" },
        { date: "2024-11-07", type: "A", content: "A" },
        { date: "2024-11-10", type: "W", content: "W" },
        { date: "2024-11-24", type: "W", content: "W" },
    ];

    return <Space direction="horizontal">
        <CommonCalendar events={events} />
        <CommonCalendar events={events} />
    </Space>
}

export default ShiftSchedule;